import React from "react";

export function Input({ className = "", label, ...props }) {
  return (
    <label className="block">
      {label && (
        <span className="block text-[11px] uppercase tracking-wider text-muted mb-1.5">
          {label}
        </span>
      )}
      <input
        className={`w-full h-9 px-3 bg-surface2 border border-line rounded-sm text-sm text-ink placeholder:text-faint transition-colors duration-150 focus:outline-none focus:border-primary focus:ring-2 focus:ring-primary/40 ${className}`}
        {...props}
      />
    </label>
  );
}
